// Central API host config — set REACT_APP_API in your .env file
const host = process.env.REACT_APP_API || 'http://localhost:5000';

export default host;

